import axios from "axios";

export default {
  namespaced: true,
  state: {
    soldCapacity: false,
    attributes: null,
    product: {
      cartIndex: null, // if has defined, then is editing product from cart
      type: null,
      id: null,
      product_variant_id: null,
      slug: null,
      name: null,
      price: 0,
      qty: 1,
      // standText, primaryText
      attributes: {},
      // originalFile, croppedFile
      files: {},
      attribute_values: {},
      services: [],
    },
    // !custom
    range: 60,
    showQR: false,
    showTimeline: false,
    showSecondaryText: false,
  },
  getters: {
    getProduct: (state) => state.product,
    getAttributes: (state) => state.attributes,
    // !custom
    getSoldCapacity: (state) => state.soldCapacity,
    getRange: (state) => state.range,
    getShowQR: (state) => state.showQR,
    getShowTimeline: (state) => state.showTimeline,
    getShowSecondaryText: (state) => state.showSecondaryText,
  },
  mutations: {
    SET_PRODUCT(state, payload) {
      state.product = payload;
    },
    SET_ATTRIBUTES(state, payload) {
      state.attributes = payload;
    },
    SETUP_PRODUCT(state, payload) {
      let attributes = {};
      let attributeValues = {};

      for (const slug in state.attributes) {
        attributeValues[slug] = state.attributes[slug].attribute_values[0];
      }

      if ([1, 4, 5].includes(payload.category_id)) {
        // lover, custom, photo
        attributes.isHorizontal = false;
      }

      if (payload.category_id === 2) {
        // insta
        attributes.activeStories = false;
        attributes.approvedAccount = false;
        attributes.likedPhoto = false;
      }

      state.product = Object.assign(payload, {
        qty: 1,
        attributes: attributes,
        files: {},
        attribute_values: attributeValues,
        services: [],
      });
    },
    REMOVE_PRODUCT_SERVICES(state, payload) {
      state.product.services = state.product.services.filter(
        (service) => service.id != payload.id
      );
    },
    PUSH_PRODUCT_SERVICE(state, payload) {
      state.product.services.push(payload);
    },
    INCREMENT_QTY(state) {
      ++state.product.qty;
    },
    DECREMENT_QTY(state) {
      if (state.product.qty > 1) {
        --state.product.qty;
      }
    },
    // !custom
    // music product
    SET_RANGE(state, payload) {
      state.range = payload;
    },
    SET_SHOW_QR(state, payload) {
      state.showQR = payload;
    },
    SET_SHOW_TIMELINE(state, payload) {
      state.showTimeline = payload;
    },
    // custom product
    SET_SECONDARY_TEXT(state, payload) {
      state.showSecondaryText = payload;
    },
  },
  actions: {
    CALCULATE_PRICE({ state }) {
      let attributeValues = [];

      for (const key in state.product.attribute_values) {
        attributeValues.push(state.product.attribute_values[key].id);
      }

      const data = {
        id: state.product.id,
        attribute_values: attributeValues,
      };

      return new Promise((resolve, reject) => {
        axios
          .post(`/api/product/variant`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
